import { put, takeEvery, all } from 'redux-saga/effects';
import * as constants from '../constants/elesson';
import * as elessonPageActions from '../actions/elesson';
import { SecurityContextType, MessageState } from '../../models/components/announcement.d';
import { Log } from 'ng2-logger';
import { Common } from '../../core/common';
import { ElessonService } from '../../api/elesson-service';
import { Notification } from '../../components/notification/main';
import * as coreActions from '../actions/core';


import Translator from '../../core/i18n';
const T = Translator.create();
const _logger = Log.create('Elesson Saga');
const _elessonService = new ElessonService();
let _common: Common;

_common = new Common();


//#region "Add Assignment Activity Saga"
function* setAddElessonActivity(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        const pageData = yield _elessonService.RequestAddElessonActivityAsync(params).then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData.json();
        }).then((response) => {
            if (isError) {
                errorList = response;
            } else {
                return response;
            }
        });
        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
            if (params.callback) {
                params.callback(null);
            }
        }
        if (!isError) {
            yield put(coreActions.newNotification(T.t('r_add_activity_succesful_notification'), '', '', 'topRight', 'success'));
            const redirectPageParams: any = {
                submitValues: params.elessonData,
                activityId: params.elessonData.projectActivityId ? params.elessonData.projectActivityId : params.elessonData.activityId ? params.elessonData.activityId : pageData,

                termWeekId:
                    params.elessonData.termWeekIds && params.elessonData.termWeekIds[0] !== '0'
                        ? params.elessonData.termWeekIds[0]
                        : params.elessonData.termWeekIds[1]
            };
            yield put(elessonPageActions.addElessonSetAction(null));
            params.callback(redirectPageParams);
        }
    } catch (error: any) {
        yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        Notification.setNotification('error', error, 'topRight');
        if (params.callback) {
            params.callback(null);
        }
    }
}


// update elesson data!!!
function* setElessonActivity(params: any) : any {
    let isError = false;
    let errorList: any;

    try {
        yield put(elessonPageActions.addElessonSetAction(null));
        const pageData = yield _elessonService
            .RequestGetElessonAsync({ ...params, take: 20, skip: 0 })
            .then((response: Response) => {
                return response;
            })
            .then((response: Response) => {
                if (response.status !== 200) {
                    isError = true;
                }
                return response.json();
            })
            .then((responseData: any) => {
                if (isError) {
                    errorList = responseData;
                } else {
                    return responseData;
                }
            })
            .then((data: any | null) => {
                if (!data) {
                    return null;
                } else {
                    return data;
                }
            });

        if(isError) {
            errorList ? 
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            }) : Notification.setNotification('error', T.t('r_api_gen_update_activity_error'), 'topRight');

            return false;
        } else {
            yield put(elessonPageActions.addElessonSetAction(pageData, params.spinnerId, 'set'));
            return true;
        }
    } catch (error: any) {
        yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        Notification.setNotification('error', T.t('r_api_gen_update_activity_error'), 'topRight');
        return false;
    }
}

function* setDeleteElessonActivity(params: any): any {
    try {
        // yield put(coursePageActions.setCoursePageHeaderInformationData(nullData, [], false));
        const pageData = yield _elessonService.RequestDeleteElessonActivityAsync(params).then((responseData: Response) => {
            return responseData;
        }).then((data: any | null) => {
            if (data === undefined || data === false) {
                return null;
            } else {
                return data;
            }
        });

        yield put(elessonPageActions.addElessonSetAction(null));
        // tslint:disable-next-line: no-empty
    } catch (error: any) {

    }
}

function* launchElesson(params: any): any {
    let isError = false;
    let errorList: any;
    let url: any;
    yield _elessonService.RequestLaunchElesson(params ? params : null)
        .then((responseData: Response) => {
            return responseData;
        })
        .then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData.json();
        })
        .then(response => {
            if (isError) {
                errorList = response;
            } else {
                url = response;
            }
        });

    if (isError) {
        yield put(coreActions.newNotification(T.t('r_api_gen_connecttoExamApp'), '', '', 'topRight', 'error', 0, params.spinnerId, 'set'));
    } else {
        window.open(url + '&token=' + _common.GetAuthLocalStorage().access_token);

    }
}

export function* watchGetAddElessonData() {
    yield takeEvery(constants.actions.ADD_ELESSON_ACTIVITY, setAddElessonActivity);
    return null;
}

export function* watchGetDeleteElessonData() {
    yield takeEvery(constants.actions.DELETE_ELESSON_ACTIVITY, setDeleteElessonActivity);
    return null;
}

export function* watchUpdateElessonData() {
    yield takeEvery(constants.actions.ADD_ELESSON_UPDATE_ACTIVITY, setElessonActivity);
    return null;
}

export function* watchLaunchElesson() {
    yield takeEvery(constants.actions.LAUNCH_ELESSON, launchElesson);
}

//#endregion "Add Assignment Activity End Saga"

export function* ElessonSagas() {
    yield all([
        watchGetAddElessonData(),
        watchGetDeleteElessonData(),
        watchUpdateElessonData(),
        watchLaunchElesson()
    ]);
}
